import React from 'react';

const QuestionChoiceSkeleton: React.FC = () => {
  return (
    <div className="flex flex-row px-2 py-4 border rounded-lg bg-gray-300 animate-pulse">
      <div className="h-[25px] w-[25px] bg-gray-400 rounded-[4px]"></div>
      <div className="ms-3 flex-1">
        <div className="h-[25px] bg-gray-400 rounded w-3/4"></div>
      </div>
    </div>
  );
};

export default QuestionChoiceSkeleton;